export default __webpack_public_path__ + "static/media/batteraside2.7d6d4150.png";